import React, { FC, useEffect, useState } from 'react';
import { faBus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Autocomplete,
  AutocompleteRenderInputParams
} from 'formik-material-ui-lab';
import {
  TIPOS_SERVICIO_VIAJE_TRASLADO,
  TipoServicioLabel,
  ViajeTrasladoTipoServicio
} from '../../models';
import { ClientBusinessModel } from 'app/client/clientBusiness/models/ClientBusiness';
import { AuthorizedModel } from 'app/client/clientBusiness/Authorized/models/Authorized';
import { RateModel } from 'app/client/clientBusiness/rates/models/RateModel';
import { BusType } from '../../models/TransferReservation';
import { Query } from '@vadiun/react-hooks-legacy';
import {
  ErrorMessage,
  Field,
  FormikErrors,
  FormikProps,
  useFormikContext
} from 'formik';
// import FormikOnFieldChange from 'shared/components/FormikOnFieldChange';
import {
  FormControl,
  InputLabel,
  MenuItem,
  TextField as TextFieldMaterial
} from '@material-ui/core';
import { CheckboxWithLabel, Select, TextField } from 'formik-material-ui';
import {
  TransferReservationBatchFormType,
  TransferReservationBatchTripFormType
} from './TransferReservationBatchFormType';
// import FormikOnFieldChange from 'shared/components/FormikOnFieldChange';

interface VehicleBatchFormProps extends FormikProps<any> {
  autorizadosQuery: Query<AuthorizedModel[]>;
  clientBusiness: ClientBusinessModel | undefined;
  fixedRates: any;
  optionsBuses?: BusType[];
  isValidation?: boolean;
  errors: FormikErrors<any>;
  index: number;
}

const VehicleBatchForm: FC<VehicleBatchFormProps> = ({
  autorizadosQuery,
  clientBusiness,
  fixedRates,
  optionsBuses,
  index
}) => {
  const [showBusesFields, setShowBusesFields] = useState<boolean>(false);
  const {
    values,
    setFieldValue,
    errors,
    touched,
    setFieldTouched,
    isSubmitting
  } = useFormikContext<TransferReservationBatchFormType>();
  const tripErrors = errors.viajes?.[
    index
  ] as FormikErrors<TransferReservationBatchTripFormType>;

  const [fixedRatesOptions, setFixedRatesOtions] = useState<any[]>([]);

  // Sincronizar showBusesFields con el valor inicial de tipoServicio
  useEffect(() => {
    const currentTipoServicio = values.viajes?.[index]?.tipoServicio;
    if (currentTipoServicio === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES) {
      setShowBusesFields(true);
    } else {
      setShowBusesFields(false);
    }
  }, [values.viajes?.[index]?.tipoServicio, index]);

  useEffect(() => {
    if (tripErrors?.bus_provider_price) {
      setFieldTouched(`viajes.${index}.bus_provider_price`, true);
    }
    if (tripErrors?.bus_customer_price) {
      setFieldTouched(`viajes.${index}.bus_customer_price`, true);
    }
  }, [isSubmitting]);



  useEffect(() => {
    if (fixedRates.categories) {
      setFixedRatesOtions(
        fixedRates.categories.find(
          (rate) => rate.name === values.viajes[index].tipoServicio
        )?.fixedPrices || []
      );
    } else {
      setFixedRatesOtions([]);
    }
  }, [fixedRates, values.viajes[index].tipoServicio]);

  return (
    <>
      <div className="grid grid-cols-2 gap-6 border-b-2 border-dashed py-8">
        <FormControl variant="outlined" fullWidth className="col-span-1">
          <InputLabel>Tipo de servicio</InputLabel>
          <Field
            component={Select}
            name={`viajes.${index}.tipoServicio`}
            label="Tipo de servicio"
            onChange={(e) => {
              setFieldValue(`viajes.${index}.tipoServicio`, e.target.value);
              setFieldValue(`viajes.${index}.fixedRate`, null);
              if (
                e.target.value === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES
              ) {
                setShowBusesFields(true);
                setFieldValue(`viajes.${index}.bus_type_id`, 2);
                setFieldValue(`viajes.${index}.bus_customer_price`, undefined);
                setFieldValue(`viajes.${index}.bus_provider_price`, undefined);
                setFieldValue(`viajes.${index}.bus_is_outsourced`, false);
                setFieldValue(`viajes.${index}.bus_observation`, undefined);
              } else {
                setShowBusesFields(false);
                setFieldValue(`viajes.${index}.bus_type_id`, undefined);
                setFieldValue(`viajes.${index}.bus_customer_price`, undefined);
                setFieldValue(`viajes.${index}.bus_provider_price`, undefined);
                setFieldValue(`viajes.${index}.bus_is_outsourced`, false);
                setFieldValue(`viajes.${index}.bus_observation`, undefined);
              }
            }}
            helperText={
              touched.viajes?.[index]?.tipoServicio && tripErrors?.tipoServicio
            }
            error={
              tripErrors?.tipoServicio && touched.viajes?.[index]?.tipoServicio
            }
          >
            {TIPOS_SERVICIO_VIAJE_TRASLADO.map((canal) => (
              <MenuItem value={canal} key={canal}>
                {TipoServicioLabel[`${canal}`]}
              </MenuItem>
            ))}
          </Field>
          <ErrorMessage name={`viajes.${index}.tipoServicio`}>
            {(msg) => <p className="mt-4 text-sm text-red-500">{msg}</p>}
          </ErrorMessage>
        </FormControl>
        {!showBusesFields ? (
          <Field
            name={`viajes.${index}.fixedRate`}
            component={Autocomplete}
            fullWidth
            getOptionLabel={(
              rate: RateModel['categories'][0]['fixedPrices'][0]
            ) => `${rate.name} - $${rate.price}`}
            noOptionsText="No se han encontrado resultados"
            loadingText="Cargando..."
            options={fixedRatesOptions}
            renderInput={(params: AutocompleteRenderInputParams) => (
              <TextFieldMaterial
                {...params}
                label="Tarifa fija"
                variant="outlined"
                InputProps={{
                  ...params.InputProps
                }}
                fullWidth
              />
            )}
          />
        ) : (
          <>
            <FormControl variant="outlined" fullWidth className="col-span-1">
              <InputLabel>Tipo de bus</InputLabel>
              <Field
                component={Select}
                name={`viajes.${index}.bus_type_id`}
                label="Tipo de bus"
                placeholder="Seleccione un tipo de bus"
                defaultValue={14}
              >
                {optionsBuses?.map(({ id: key, name }) => {
                  return (
                    <MenuItem value={key} key={key}>
                      <div className="flex items-center w-full">
                        <div className="w-8">
                          <FontAwesomeIcon
                            icon={faBus}
                            color="#8EC3E6"
                            size="1x"
                          />
                        </div>
                        <p className="m-0">{name}</p>
                      </div>
                    </MenuItem>
                  );
                })}
              </Field>
            </FormControl>
            <div className="flex gap-4">
              <Field
                name={`viajes.${index}.bus_provider_price`}
                label="Costo proveedor"
                variant="outlined"
                component={TextField}
                type="number"
              />
              <Field
                name={`viajes.${index}.bus_customer_price`}
                label="Costo cliente"
                variant="outlined"
                component={TextField}
                type="number"
              />
            </div>
            <div className="w-32">
              <Field
                component={CheckboxWithLabel}
                type="checkbox"
                name={`viajes.${index}.bus_is_outsourced`}
                color="primary"
                Label={{ label: 'Tercerizado' }}
              />
            </div>
            <Field
              name={`viajes.${index}.bus_observation`}
              label="Observaciones buses"
              variant="outlined"
              component={TextField}
              className="col-start-1 col-end-3"
              fullWidth
            />
          </>
        )}
      </div>
    </>
  );
};

export default VehicleBatchForm;
